
import { Component, Vue, Prop } from 'vue-property-decorator'
import BaseInformationForm from '@/components/processing_steps/funding_scope/forms/BaseInformationForm.vue'
import FormContainer from '../../commons/forms/FormContainer.vue'
import AddressForm from '../../commons/forms/AddressForm.vue'
import DocumentField from '../../commons/fields/DocumentField.vue'
import { IPhoto } from '@/types/photos'
import { IPSFundingScopeBaseForm, IPSFundingScopeBaseFormErrors, IPSAddressForm, IPSAddressFormErrors } from '@/types/processingSteps'

@Component({
  components: {
    BaseInformationForm,
    FormContainer,
    AddressForm,
    DocumentField
  }
})
export default class BaseInformationStep extends Vue {
  @Prop() fundingScopeForm!: IPSFundingScopeBaseForm
  @Prop() fundingScopeFormErrors!: IPSFundingScopeBaseFormErrors
  @Prop() availableOrganizations!: { value: string, text: string }[]
  @Prop() addressForm!: IPSAddressForm
  @Prop() addressFormErrors!: IPSAddressFormErrors
  @Prop() logoUploadUrl!: string
  @Prop() existingLogos!: IPhoto[]
  @Prop() enterOrganizationsAddress!: () => void
  @Prop() onLogoUploadClicked!: () => void
  @Prop() handlePhotoUpdated!: () => void
  @Prop() orgaUserCanEdit!: boolean
  @Prop({ default: true }) canChangeCountry!: boolean
}
